import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'libby-shop-cart-v1';

function readCart() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeCart(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export default function useCart() {
  const [items, setItems] = useState(readCart);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    writeCart(items);
  }, [items]);

  const addItem = useCallback((slug, quantity = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i.productSlug === slug);
      if (existing) {
        return prev.map(i =>
          i.productSlug === slug ? { ...i, quantity: Math.min(99, i.quantity + quantity) } : i
        );
      }
      return [...prev, { productSlug: slug, quantity }];
    });
    setDrawerOpen(true);
  }, []);

  const setQuantity = useCallback((slug, quantity) => {
    const qty = Math.max(0, Math.min(99, quantity));
    setItems(prev => {
      if (qty === 0) return prev.filter(i => i.productSlug !== slug);
      return prev.map(i => (i.productSlug === slug ? { ...i, quantity: qty } : i));
    });
  }, []);

  const removeItem = useCallback(slug => {
    setItems(prev => prev.filter(i => i.productSlug !== slug));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const itemCount = items.reduce((sum, i) => sum + i.quantity, 0);

  return {
    items,
    itemCount,
    drawerOpen,
    setDrawerOpen,
    addItem,
    setQuantity,
    removeItem,
    clearCart,
  };
}
